import { HALCYON_FORM_INCLUSION_SCHEMA_ACTION_TYPE } from '../actions';

const initialState = {};

const halcyonFormInclusionSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case HALCYON_FORM_INCLUSION_SCHEMA_ACTION_TYPE.GET_HALCYON_FORM_INCLUSION_SCHEMA:
      return payload || state;

    default:
      return state;
  }
};

export default halcyonFormInclusionSchemaReducer;
